import { Navigate, useParams } from 'react-router-dom';
import { ReactNode } from 'react';
import { usePermissions } from '@/contexts/WorkspaceContext';
import { PermissionKey } from '@/lib/permissions';

interface RequireRoleProps {
  permission: PermissionKey;
  children: ReactNode;
}

// Capability gate for a workspace page. Renders inside WorkspaceProvider, so it
// reads the caller's API-provided permissions. The backend enforces the same
// permission independently — this is only for UX.
export default function RequireRole({ permission, children }: RequireRoleProps) {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const { can } = usePermissions();
  if (!can(permission)) {
    return <Navigate to={'/w/' + workspaceId + '/dashboard'} replace />;
  }
  return <>{children}</>;
}
